<template>
  <div id="app" class="h-full">
    <vue-page-transition name="fade" class="h-full">
      <RouterView :key="$route.fullPath" />
    </vue-page-transition>
    <!--end::route-views-->

    <audio ref="audioClick" :src="require('@assets/audio/click.mp3')" class="invisible"></audio>
    <!--end::audios-->
  </div>
</template>

<script>
import appConfig from '@src/app.config'
import { EVENT, LAYOUT } from '@src/games/constant'
import Audio from '@utils/browser-audio'
import { LAYOUTS } from '@state/modules/layout'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title}` : appConfig.title
    },
  },
  data() {
    return {
      verticalMode: false,
    }
  },
  computed: {
    audioClick() {
      return this.$refs.audioClick
    },
  },
  beforeMount() {
    window.onload = this.onload
  },
  mounted() {
    this.initAudios()
    this.verticalMode = window.innerHeight > LAYOUT.BASE_VERTICAL_HEIGHT
    this.$store.commit(LAYOUTS.NAMESPACE(LAYOUTS.SET_IS_VERTICAL_SCREEN), this.verticalMode)
    document.addEventListener('dblclick', (e) => e.preventDefault())
    document.addEventListener('click', window.audios.click.play)
  },
  beforeDestroy() {
    document.removeEventListener('dblclick', (e) => e.preventDefault())
    document.removeEventListener('click', window.audios.click.play)
  },
  methods: {
    onload() {
      this.$events.emit(EVENT.DOCUMENT_READY)
    },
    initAudios() {
      window.audios = {
        click: new Audio(this.audioClick),
      }
    },
  },
}
</script>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// tailwindcss
@import '~@assets/css/tailwindcss.min.css';
// loading overlay
@import '~vue-loading-overlay/dist/vue-loading.css';
// perfect scrollbar
@import '~vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.min.css';
// swiper
@import '~swiper/swiper-bundle.min.css';
// animatec.css
@import '~animate.css/animate.min.css';

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';

// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
@import '@design';
</style>
